import service from '@/utils/server';

const modName = '/bd/orderSingleCreate/';
const modNameSoldCreate = '/bd/soldCreate/';


//查询方法
export const pageInfo = data => {
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  })
};
//新增保存方法
export const saveData = data => {
  return service({
    url: modName + 'add',
    method: 'post',
    data
  })
};
//修改保存方法
export const editData = data => {
  return service({
    url: modName + 'update',
    method: 'post',
    data
  })
};
//删除方法
export const deleteData = data => {
  return service({
    url: modName + 'delete/' + data.id,
    method: 'post'
  })
};

//信贷信息
export const initAdd = data => {
  return service({
    url: modName + 'initAdd',
    method: 'post',
    data
  })
};

//产品列表
export const materilePage = data => {
  return service({
    url: modName + 'materilePage',
    method: 'post',
    data
  })
};

//偏好设置
export const preferenceSet = data => {
  return service({
    url: modName + 'preferenceSet',
    method: 'post',
    data
  })
};

//预提交订单
export const orderPreSubmit = data => {
  return service({
    url: modName + 'orderPreSubmit',
    method: 'post',
    data
  })
};

//提交订单
export const orderSubmit = data => {
  return service({
    url: modName + 'orderSubmit',
    method: 'post',
    data
  })
};

//产品价格
export const materilePrice = data => {
  return service({
    url: modName + 'materilePrice',
    method: 'post',
    data
  })
};

//查询信贷余额
export const getCreditBalanceData = data => {
  return service({
    url: modName + 'searchCreditBalance',
    method: 'post'
  })
};

//查询经销商对应的送达方起订量数据
export const getMoqSettingInfo= data => {
  return service({
    url: modName + 'queryMoqSetting/'+data,
    method: 'post'
  })
};

//查询订单保存的信息
export const intOrderSaveDetail= data => {
  return service({
    url: modName + 'orderSaveDetail/'+data,
    method: 'post'
  })
};

//
// 保存订单
export const orderSaveData = data => {
  return service({
    url: modName + 'orderSave',
    method: 'post',
    data
  })
};

//订单编辑
export const orderEdit = data => {
  return service({
    url: '/bd/orderBatchCreate/orderEdit',
    method: 'post',
    data
  })
};

//模版下载
export const downloadTemplate = data => {
  let config = {
    timeout: 500000, // 请求超时时间
    responseType: "blob"
  };
  return service({
    ...config,
    url: '/bd/orderBatchCreate/template/' + data.templateName,
    method: 'post',
    data
  });
};

//导入
export const uploadOrder = data => {
  let config = {
    timeout: 500000, // 请求超时时间
    headers: {
      "Content-Type": "multipart/form-data"
    },
    responseType: "blob"
  };
  return service({
    ...config,
    url: '/bd/orderBatchCreate/uploadOrder',
    method: 'post',
    data
  });
};

//特殊地址备用列表
export const specialAddressBackup = data => {
  return service({
    url: modNameSoldCreate + 'specialAddressBackup',
    method: 'post',
    data
  })
};



// WEBPACK FOOTER //
// ./src/page/order/create/api/index.js